module.exports = "<h1 ng-bind-html=\"element.data.text\"></h1>"